var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import clsx from 'clsx';
export const Label = props => {
    const { hidden = false, helperText, children, className } = props, rest = __rest(props, ["hidden", "helperText", "children", "className"]);
    const label = (React.createElement("label", Object.assign({ className: clsx('block font-medium text-basicSurface-700', hidden && 'sr-only', className) }, rest), children));
    if (helperText) {
        return (React.createElement("div", { className: "flex justify-between" },
            label,
            React.createElement("span", { className: "text-sm text-basicSurface-500" }, helperText)));
    }
    return label;
};
//# sourceMappingURL=Label.js.map